module.exports = __webpack_public_path__ + "img/icon1.cb7874e8.png";